import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '@store/policies/mbrPolicy/actions';
import { selector } from '@store/policies/mbrPolicy';
import PrecisionTab from '@components/common/Dashboard/DashboardTabs/PrecisionTab';
import MbrTab from '@components/common/Dashboard/DashboardTabs/MbrPolicyTab';
import { IVersion } from './types';
import { PolicyVersion, PolicyWrapper, PolicyFilter } from '../common';
import { Rates, Tabs, Wrapper, StyledTabs } from './styled';

const renderPolicies = (policies) =>
  policies
    .sort((a, b) => a.index - b.index)
    .map((policy, idx) => (
      <PolicyWrapper key={policy.id}>
        <PolicyFilter policy={policy} index={idx + 1} />
        {(policy.versions as IVersion[]).map((version) => (
          <PolicyVersion key={version.id} policy={policy} version={version}>
            <Rates>
              <table>
                <thead>
                  <tr>
                    <th>Starting Bitrate</th>
                    <th>Min Bitrate</th>
                    <th>Max Bitrate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{version.start_bitrate_kbps}kbps</td>
                    <td>{version.min_bitrate_kbps}kbps</td>
                    <td>{version.max_bitrate_kbps}kbps</td>
                  </tr>
                </tbody>
              </table>
            </Rates>
          </PolicyVersion>
        ))}
      </PolicyWrapper>
    ));

const MbrPolicy = () => {
  const dispatch = useDispatch();
  const { policies } = useSelector(selector);

  useEffect(() => {
    dispatch(actions.init());
  }, [dispatch]);

  const renderedPolicies = renderPolicies(policies);

  return (
    <Wrapper>
      <StyledTabs>
        <PrecisionTab />
      </StyledTabs>
      <Tabs>
        <MbrTab />
      </Tabs>
      {renderedPolicies}
    </Wrapper>
  );
};

export default MbrPolicy;
